// import 'bootstrap';
import { Tooltip } from 'bootstrap'

import ready, { HTML } from './utils';
import initUtilites from './utils/initUtilities';
import initFixedPanel from './components/initFixedPanel';
import initSmoothScroll from './components/initSmoothScroll';
import initMobilFormTabs from './components/initMobilFormTabs';
import initAccessibilityNav from './components/initAccessibilityNav';
import initCollapsible from './components/initCollapsible';
import initPageHeader from './components/initPageHeader';
import initAnnouncementPanel from './components/initAnnouncementPanel';
import initSearchDrop from './components/initSearchDrop';
import initSliderMod from './components/initSliderMod';
import initCarouselBlockQuoteSection from './components/initCarouselBlockQuoteSection';
import internalNav from './components/internalNav';
import initTeamMemberMod from './components/initTeamMemberMod';
import pageToggle from './components/pageToggle';
import initVideoMod from './components/initVideoMod';
import initAudioMod from './components/initAudioMod';
import initCardTypes from './components/initCardsMod';
import initQuoteImageCarousel from './components/initQuoteImageCarousel';
import initTables from './components/initTables';
import initTooltips from './components/initTooltips';
import initStatsBlock from './components/initStatsBlock';
import initSearch from './search/search';
import initLargeCardCarousel from './components/initLargeCardCarousel';
import initFavorites from './components/initFavorites';
import initForms from './components/initForms';
import initDyanmicResourceCenter from './components/initDynamicResourceCenter';
import initCalculators from './calculators/calculators';
import initPageEdge from './components/initPageEdge';
import initModals from './components/initModals';
import initTabbedResourceCarousel from './components/initTabbedResourceCarousel';
import initTeamGridCarousel from './components/initTeamGridCarousel';
import initDottedGraphicLine from './components/initDottedGraphicLine';
import initLanguage from './components/initLanguage';
import initExternalLink from './components/initExternalLink';
import initScrollLockBlock from './components/initScrollLockBlock';
import initTabbedCarouselControls from './components/initTabbedCarouselControls';
import initNavAnchorSection from './components/initNavAnchorSection';
import initVideoModals from './components/initVideoModals';

ready(() => {

	try{
		initUtilites();
	}catch(e){
		console.log("initUtilites error", e);
	}

	try{
		initExternalLink();
	}catch(e){
		console.log("initExternalLink error", e);
	}

	try{
		initSmoothScroll();
	}catch(e){
		console.log("initSmoothScroll error", e);
	}

	try{
		initMobilFormTabs();
	}catch(e){
		console.log("initMobilFormTabs error", e);
	}

	try{
		initSearchDrop();
	}catch(e){
		console.log("initSearchDrop error", e);
	}

	try{
		initAccessibilityNav();
	}catch(e){
		console.log("initAccessibilityNav error", e);
	}

	try{
		initCollapsible();
	}catch(e){
		console.log("initCollapsible error", e);
	}

	try{
		initPageHeader();
	}catch(e){
		console.log("initPageHeader error", e);
	}

	try{
		initAnnouncementPanel();
	}catch(e){
		console.log("initAnnouncementPanel error", e);
	}

	try {
		initTabbedCarouselControls();
	} catch (e) {
		console.log("initTabbedCarouselControls error", e);
	}

	try{
		initQuoteImageCarousel();
	}catch(e){
		console.log("initQuoteImageCarousel error", e);
	}

	try{
		initStatsBlock();
	}catch(e){
		console.log("initStatsBlock error", e);
	}

	try{
		initSearch();
	}catch(e){
		console.log("initSearch error", e);
	}

	try{
		initCardTypes();
	}catch(e){
		console.log("initCardTypes error", e);
	}

	try{
		initCarouselBlockQuoteSection();
	}catch(e){
		console.log("initCarouselBlockQuoteSection error", e);
	}

	try{
		initSliderMod();
	}catch(e){
		console.log("initSliderMod error", e);
	}

	try{
		internalNav();
	}catch(e){
		console.log("internalNav error", e);
	}

	try{
		initTeamGridCarousel();
	}catch(e){
		console.log("initTeamGridCarousel error", e);
	}

	try{
		initTeamMemberMod();
	}catch(e){
		console.log("initTeamMemberMod error", e);
	}

	try{
		pageToggle();
	}catch(e){
		console.log("pageToggle error", e);
	}

	try{
		initVideoMod();
	}catch(e){
		console.log("initVideoMod error", e);
	}

	try{
		initAudioMod();
	}catch(e){
		console.log("initAudioMod error", e);
	}

	try{
		initTables();
	}catch(e){
		console.log("initTables error", e);
	}

	try{
		initTooltips();
	}catch(e){
		console.log("initTooltips error", e);
	}

	try{
		initLargeCardCarousel();
	}catch(e){
		console.log("initLargeCardCarousel error", e);
	}

	try{
		initForms();
	}catch(e){
		console.log("initForms error", e);
	}

	try{
		initFavorites();
	}catch(e){
		console.log("initFavorites error", e);
	}

	try{
		initDyanmicResourceCenter();
	}catch(e){
		console.log("initDyanmicResourceCenter error", e);
	}

	try{
		initTabbedResourceCarousel();
	}catch(e){
		console.log("initTabbedResourceCarousel error", e);
	}

	try{
		initCalculators();
	}catch(e){
		console.log("initCalculators error", e);
	}

	try{
		initPageEdge();
	}catch(e){
		console.log("initPageEdge error", e);
	}

	try{
		initModals();
	}catch(e){
		console.log("initModals error", e);
	}

	try{
		initLanguage();
	}catch(e){
		console.log("initLanguage error", e);
	}

	try{
		initFixedPanel();
	}catch(e){
		console.log("initFixedPanel error", e);
	}

	try{
		initDottedGraphicLine();
	}catch(e){
		console.log("initDottedGraphicLine error", e);
	}

	try{
		initScrollLockBlock();
	}catch(e){
		console.log("initScrollLockBlock error", e);
	}

	try {
		initNavAnchorSection();
	} catch (e) {
		console.log("initNavAnchorSection error", e);
	}

	try{
		initVideoModals();
	}catch(e){
		console.log("initVideoModals error", e);
	}

	/** small delay to hide JS **/
	HTML.classList.add('is-loaded');
	setTimeout(() => {
		document.querySelector('body').style.opacity = 1;
	}, 100 );

});
